var _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHomeIndicator(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 138,
    height: 5,
    viewBox: "0 0 138 5",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Home Indicator",
    width: 138,
    height: 5,
    rx: 2.5,
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeIndicator);
export default __webpack_public_path__ + "static/media/HomeIndicator.48ea53d77852ebae804d9bf0f72f2551.svg";
export { ForwardRef as ReactComponent };